import angular from 'angular';
import insuranceQuoteModsWidget from './insuranceQuoteModsWidget';
import './style.scss';

export default angular
  .module('components.insuranceQuoteModsWidget', [])
  .component('insuranceQuoteModsWidget', insuranceQuoteModsWidget).name;
